import { Box, Typography } from '@dtx-company/design-system/src'
import Image from 'next/image'
import { FC } from 'react'

const MARK_SIZE_PX = 26

const InlineTrademarkMark: FC<{ src: string }> = ({ src }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      verticalAlign: 'middle',
      lineHeight: 0
    }}
  >
    <Image
      src={src}
      alt=""
      width={MARK_SIZE_PX}
      height={MARK_SIZE_PX}
      aria-hidden
      style={{ objectFit: 'contain', display: 'block' }}
    />
  </Box>
)

export const FooterTrademarkNotice: FC = () => {
  return (
    <Box
      sx={{
        p: {
          letterSpacing: 'normal',
          fontWeight: 400
        }
      }}
    >
      <Typography variant="labelSmall" component="p">
        FLOWCODE, FLOWPAGE,{' '}
        <InlineTrademarkMark src="/images/trademark-codes/trademark-code-1.svg" />
        {', and '}
        <InlineTrademarkMark src="/images/trademark-codes/trademark-code-2.svg" />
        {', are registered trademarks of the dtx company, dba Flowcode.'}
      </Typography>
    </Box>
  )
}
